// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__nErVr","footer":"ChangeClinic_footer__1yPnM"};